import React from 'react';
import styled from 'styled-components';
import Title from './forms/Title';
import { clearAllPersistedState } from './stateProvider/UsePersistedState';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1em;
`

const Button = styled.button`
    margin: 1em;
`

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error(error)
    }

    render() {
        if (this.state.hasError) {
            return (
                <Wrapper>
                    <Title icon='exclamationTriangle'>An Error has occurred</Title>
                    <div>An Error has occurred resulting in the application crashing.</div>
                    <Button
                        onClick={() => {
                            clearAllPersistedState();
                            window.location = window.location.protocol + '//' + window.location.host;
                        }}
                    >
                        Reload Application
                    </Button>
                </Wrapper>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;